import api from "../../../api/axios";

// Feature-local POST wrapper for company join-request creation.
// Mirrors features/companyJoinRequest/api/joinRequests.js byte-for-
// byte (Phase 11). Phase 15 keeps a feature-local copy so it can
// evolve independently if dependent-resource sequencing surfaces
// new error-shape requirements — but for now the call is identical.
//
// Endpoint: POST /api/companies/{companyId}/join-requests/
// Body:     { message? }  — omit message entirely when empty (see
//                            migration/phase11-multi-field-plan.md §5.3).
// Auth:     IsAuthenticated.
// Response 201: CompanyJoinRequestSerializer payload.
// Errors:
//   403 — company is not open to join requests.
//   400 — already a member, unique_pending_join_request, serializer
//         field errors on `message`, or non_field_errors.
//
// Stateless request wrapper. No cache. No retry. No orchestration.
export const createJoinRequest = (companyId, body) =>
  api
    .post(`/companies/${companyId}/join-requests/`, body)
    .then((res) => res.data);
